import Footer from '@/components/Footer';
import Header from '@/components/Header';
import LessonCourseBanner from '@/ui/components/LessonCourseBanner';
import Container from '@/ui/molecules/Container';

type Props = {
  children?: React.ReactNode;
  isLessonCourseBanner?: boolean;
};

const Component: React.FC<Props> = ({
  children,
  isLessonCourseBanner = false,
}) => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex-1 overflow-x-hidden">
        <Container>
          <div className="py-3 md:py-8">{children}</div>
        </Container>
      </div>
      <Footer />
      {isLessonCourseBanner && <LessonCourseBanner />}
    </div>
  );
};

export default Component;
